import { useState } from 'react'

import { Box, Button, Icon, Modal, Text } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { getReadableNumber } from '../../utilities/strings/getReadableNumber'

import * as Styles from './card.styles'
import { CardProps } from './card.types'

export const Card = ({
  title,
  value,
  icon = 'building3',
  color = 'secondary',
  seeMore,
  width,
  hideIcon,
}: CardProps) => {
  const [openSeeMore, setOpenSeeMore] = useState(false)
  const theme = useTheme()

  const getValue = () => {
    if (parseFloat(value)) {
      return getReadableNumber(parseFloat(value))
    }
    return value
  }

  return (
    <Box
      borderRadius="16px"
      backgroundColor="white"
      padding={3}
      direction="column"
      width={width || '100%'}
      maxWidth="100%"
      minWidth="200px"
      flex={1}
      boxShadow={theme.box_shadow.card}
    >
      <Box
        justifyContent="space-between"
        width="100%"
        alignItems="center"
        marginBottom={hideIcon ? 0 : 2}
      >
        {!hideIcon && (
          <Styles.IconContainer color={color}>
            <Styles.StyledIcon name={icon} color={color} size={24} />
          </Styles.IconContainer>
        )}
        {!!seeMore?.length && (
          <Button
            width="24px"
            padding="0"
            variant="text"
            borderRadius="50%"
            onClick={() => setOpenSeeMore(true)}
          >
            <Icon name="add_box" color="grey_3" size={24} />
          </Button>
        )}
      </Box>
      <Box direction="column" height="80px" justifyContent="space-between">
        <Styles.Title color="grey_2">{title}</Styles.Title>
        <Styles.Value color="grey_1">{getValue()}</Styles.Value>
      </Box>
      {!!seeMore?.length && (
        <Modal
          open={openSeeMore}
          onClose={() => setOpenSeeMore(false)}
          title={title}
          width="600px"
          maxWidth="90%"
        >
          <Box padding={2} direction="column" width="100%">
            {seeMore?.map((item, index) => (
              <Box key={`item-${index}`} gap={2} width="100%">
                <Text color="grey_3">{`${index + 1}.`}</Text>
                <Text color="grey_1">{item}</Text>
              </Box>
            ))}
          </Box>
        </Modal>
      )}
    </Box>
  )
}
